import React, { PureComponent } from 'react'
import { APP_URL } from '../../utils/config.js'
import {
  addToCart,
  setBeenThrough,
  setCanProceedToNextStep,
  setCordFabricDirection,
  setFabricDirection,
  setSelectedCordFabric,
  setSelectedFabric,
  setSingleCordFabric,
  setSingleFabric,
} from '../../actions/generalActions.js'
import { connect } from 'react-redux'
import { withRoutingTracker } from '../../HOC/withRoutingTracker.js'
import Filters from './Filters.js'
import _, { cloneDeep } from 'lodash'
import { BarLoader } from 'react-spinners'
import {
  createError,
  displayPromiseToast,
  displayToast,
  getEstimate,
  scrollTo,
  sendGtag,
  setURLParams,
} from '../../utils/utils.js'
import { NUMBER_OF_DAYS_FOR_NEW_ITEM } from '../../utils/constants.js'
import {
  getFabricsForKits,
  getMoreFabrics,
  setFilteredCordingFabrics,
  setFilteredFabrics,
  setScrollPosition,
} from '../../actions/fabricsActions.js'
import NewItemOverlay from '../NewItemOverlay.js'
import { ReactComponent as CustomFabric } from '../../../assets/icons/custom-fabric.svg'

class Fabrics extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isMobileLayout: false,
      isMobileDevice: false,
      favouriteFabrics: [],
      page: 1,
      isLoadingMoreFabrics: false,
      loadedAllFabrics: false,
      lastFabricsFilters: [],
    }

    this.fabricsList = React.createRef()
    this.fabricsContianer = React.createRef()
  }

  componentDidMount() {
    const { general, params, dispatch, fabrics, history, switchCurrentView, conditionForProceed } =
      this.props
    const { cordFabric, fabric, fabricDirection, beenThrough, enableScrollTo } = general
    const userAgent = window.navigator.userAgent
    const mobileKeywords = ['Mobile', 'Android', 'iOS', 'Windows Phone']

    this.setState({
      isMobileLayout: window.innerWidth < 1024,
      isMobileDevice: mobileKeywords.some((keyword) => userAgent.includes(keyword)),
      favouriteFabrics: JSON.parse(localStorage.getItem('favourites')) || [],
    })
    const { frontendFilters } = fabrics
    // set scroll position
    const container = document.querySelector('.cushion-fabric-selector')
    container.scrollTop = fabrics.scrollTop

    this._checkForMobileLayout()

    window.addEventListener('resize', this._checkForMobileLayout)

    if (params.style && frontendFilters.length) {
      dispatch(getFabricsForKits())
      if (!cordFabric) {
        dispatch(setCordFabricDirection(params.fabric.direction))
        const selectedFabric = fabrics.filteredFabrics.find(
          (fabric) => fabric.id.toString() === params.fabric.id,
        )
        dispatch(
          setSelectedCordFabric(selectedFabric, !!selectedFabric && (conditionForProceed ?? true)),
        )
      }
      setTimeout(() => {
        this._getPrice()
      }, 500)
    }
    if (params.fabric && frontendFilters.length) {
      dispatch(getFabricsForKits())
      if (!fabric) {
        dispatch(setFabricDirection(fabricDirection))
        const selectedFabric = fabrics.fabrics.find(
          (fabric) => fabric.id.toString() === params.fabric.id,
        )
        dispatch(setSelectedFabric(selectedFabric))
      }
      setTimeout(() => {
        this._getPrice()
      }, 500)
    }

    if ((params.style && !beenThrough.style) || (params.fabric && !beenThrough.fabrics)) {
      if (enableScrollTo === true) {
        scrollTo('designer-steps', 500, 100)
      }
    }

    if (params.style) {
      if (!beenThrough.style) {
        dispatch(
          setBeenThrough({
            ...beenThrough,
            style: true,
          }),
        )
      }
    } else {
      if (!beenThrough.fabrics) {
        dispatch(
          setBeenThrough({
            ...beenThrough,
            fabrics: true,
          }),
        )
      }
    }

    setTimeout(() => {
      this._getPrice()
    }, 1000)

    const fabricID = history.location.search.split('=')[1]
    if (fabricID) {
      dispatch(
        params.style
          ? setSingleCordFabric(parseInt(fabricID))
          : setSingleFabric(parseInt(fabricID)),
      )
      switchCurrentView('single-fabric')()
    }
  }

  _setContainerScroll = () => {
    const { dispatch } = this.props
    const container = document.querySelector('.cushion-fabric-selector')
    dispatch(setScrollPosition(container.scrollTop))
  }

  _shouldCheckForBrokenLink = () => {
    const { fabrics } = this.props
    const { frontendFilters, colorApiFilters, filters } = fabrics
    return !(
      colorApiFilters.length > 0 ||
      frontendFilters.brand ||
      frontendFilters.material ||
      frontendFilters.use ||
      frontendFilters.pattern ||
      frontendFilters.colors.length > 0 ||
      filters.find((item) => item.name === 'stock_status')?.value !== 0 ||
      filters.find((item) => item.name === 'min_price')?.value ||
      filters.find((item) => item.name === 'max_price')?.value ||
      filters.find((item) => item.name === 'search')?.value ||
      filters.find((item) => item.name === 'orderby')?.value ||
      filters.find((item) => item.name === 'order')?.value
    )
  }

  componentDidUpdate(prevProps) {
    const { fabrics, params, dispatch, history, switchCurrentView, conditionForProceed } =
      this.props

    if (
      !_.isEqual(prevProps.fabrics.fabrics, fabrics.fabrics) &&
      this._shouldCheckForBrokenLink()
    ) {
      if (params.fabric) {
        const { id, direction } = params.fabric
        if (id !== 'fabric') {
          const selectedFabric = fabrics.fabrics.find(
            (fabric) => fabric.id.toString() === id.toString(),
          )
          if (selectedFabric) {
            dispatch(setFabricDirection(direction))
            dispatch(setSelectedFabric(selectedFabric, true))
            dispatch(setCordFabricDirection(direction))
            dispatch(setSelectedCordFabric(selectedFabric, null))
          }
          setTimeout(() => {
            this._getPrice()
          }, 400)
        }
      }
      if (params.style) {
        const { fabricId, fabricDirection } = params.style
        if (fabricId !== 'style') {
          const selectedFabric = fabrics.fabrics.find(
            (fabric) => fabric.id.toString() === fabricId?.toString(),
          )
          if (selectedFabric) {
            dispatch(setCordFabricDirection(fabricDirection))
            dispatch(setSelectedCordFabric(selectedFabric, conditionForProceed ?? true))
          }
          setTimeout(() => {
            this._getPrice()
          }, 400)
        }
      }
    }
    if (!this._isSame(fabrics.filters, prevProps.fabrics.filters)) {
      this.setState({ page: 1 })
    }

    if (fabrics.filters !== this.state.lastFabricsFilters) {
      this.setState({
        loadedAllFabrics: false,
      })
    }

    if (location !== prevProps.location && history.location.search !== '') {
      switchCurrentView('single-fabric')()
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._checkForMobileLayout)
  }

  _checkForMobileLayout = _.debounce(() => {
    this.setState({ isMobileLayout: window.innerWidth <= 1024 })
  }, 100)

  _toggleCushionFabric = (cushion) => () => {
    const { dispatch, general, params, switchCurrentView, conditionForProceed } = this.props
    const { fabric, cordFabric, fabricDirection, cordFabricDirection } = general

    if (params.style) {
      if (general?.fabric?.id !== cushion?.id) {
        sendGtag('select_fabric_type_style', cushion?.name)
      }
    }
    else {
      if (general?.fabric?.id !== cushion?.id) {
        sendGtag('select_fabric_type_fabrics', cushion?.name)
      }
    }

    const isDirectional =
      cushion?.attributes?.find((attr) => attr.name.toLowerCase() === 'is directional')
        ?.options[0] === 'yes'

    if (params.style) {
      dispatch(
        setSelectedCordFabric(
          cushion,
          (!isDirectional || (!!cordFabricDirection && cordFabricDirection !== 'nondirectional')) &&
            (conditionForProceed ?? true),
        ),
      )
      if (!isDirectional) {
        dispatch(setCordFabricDirection('nondirectional'))
      }
    } else {
      dispatch(
        setSelectedFabric(
          cushion,
          !isDirectional || (!!fabricDirection && fabricDirection !== 'nondirectional'),
        ),
      )
      dispatch(setSelectedCordFabric(cushion, null))
      if (!isDirectional) {
        dispatch(setCordFabricDirection('nondirectional'))
        dispatch(setFabricDirection('nondirectional'))
      }
    }

    if (
      fabric?.attributes?.find((attr) => attr.name === 'dimension') ||
      cordFabric?.attributes?.find((attr) => attr.name === 'dimension')
    ) {
      dispatch(params.style ? setCordFabricDirection(null) : setFabricDirection(null))
      dispatch(setCanProceedToNextStep(false))
    }

    if (isDirectional) {
      if (params.style) {
        dispatch(setCordFabricDirection('nondirectional'))
        dispatch(setCanProceedToNextStep(conditionForProceed ?? true))
      } else {
        switchCurrentView('single-fabric')(cushion?.id)
      }
    }

    dispatch(params.style ? setSingleCordFabric(cushion.id) : setSingleFabric(cushion.id))
    setTimeout(() => {
      this._getPrice()
    }, 500)
  }

  _selectCushionFabric = (fabric) => () => {
    const { dispatch, switchCurrentView, params, history, general } = this.props

    const currentRoute = history.location.pathname
    const isCordFabric = general.style?.id !== 789 && general.style?.id !== 741
    let isStylePage = ''
    if (general.style) {
      isStylePage = currentRoute.includes('style') || isCordFabric ? general.style.id + '-' : ''
    }

    // set scroll position
    this._setContainerScroll()

    history.push(currentRoute + '?' + isStylePage + 'viewing=' + fabric)
    dispatch(params.style ? setSingleCordFabric(fabric) : setSingleFabric(fabric))
    switchCurrentView('single-fabric')()
  }

  _toggleFavoriteFabric = (fabricId, fabricName) => () => {
    const { params } = this.props

    const currentFavourites = JSON.parse(localStorage.getItem('favourites')) || []
    if (currentFavourites.includes(fabricId)) {
      const newFavourites = currentFavourites.filter((id) => id !== fabricId)
      localStorage.setItem('favourites', JSON.stringify(newFavourites))
      this.setState({ favouriteFabrics: newFavourites })

      if (params.style) {
        sendGtag('favorites_style', `${fabricName}_Favorite value 0`)
      }
      else {
        sendGtag('favorites_fabrics', `${fabricName}_Favorite value 0`)
      }
    } else {
      localStorage.setItem('favourites', JSON.stringify([...currentFavourites, fabricId]))
      this.setState({ favouriteFabrics: [...currentFavourites, fabricId] })

      if (params.style) {
        sendGtag('favorites_style', `${fabricName}_Favorite value 1`)
      }
      else {
        sendGtag('favorites_fabrics', `${fabricName}_Favorite value 1`)
      }
    }
  }

  handleOpenFilters = () => {
    const { switchCurrentView, isStyle } = this.props
    if (isStyle) {
      sendGtag('open_mobile_filters_fabrics_style')
    }
    else {
      sendGtag('open_mobile_filters_fabrics')
    }

    switchCurrentView('filters')()
  }

  _renderHeader = () => {
    const { isMobileLayout } = this.state
    const { general, params } = this.props
    const { style } = general
    const showStock = !((style?.id === 742 && params.style) || (style?.id === 790 && params.style))

    return isMobileLayout ? (
      <div id="filters-button" className="filters-button" onClick={this.handleOpenFilters}>
        <div>
          <img src={`${APP_URL}/wp-content/uploads/2021/10/filter.png`} />
          <span>FILTERS</span>
        </div>
        <img src={`${APP_URL}/wp-content/uploads/2021/10/arrow-right.png`} />
      </div>
    ) : (
      <Filters showStock={showStock} />
    )
  }

  addToCartCallback = () => {
    if (window?.increment_cart) {
      window.increment_cart()
    }
  }

  _onBuySwatch = (fabric) => () => {
    const { dispatch, params, fabrics } = this.props

    const fabricSku = fabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'internal sku')
      ?.options[0]
    const fabricColor = fabric?.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'internal color number:',
    )?.options[0]
    const fabricBrand = fabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'brand')
      ?.options[0]
    const fabricName = fabric?.name
    const fabricMaterialName = fabric?.attributes
      ?.find((attr) => attr.name.toLowerCase() === 'material')
      ?.options[0].toLowerCase()
    const fabricMaterialID = fabrics.materials
      .map((material) => material.vals)
      .flat()
      .find((item) => item.name.toLowerCase() === fabricMaterialName)?.id

    const itemData = {
      is_swatch: true,
      pa_internal_sku: fabricSku,
      pa_attribute_brand: fabricBrand,
      pa_internal_color_number: fabricColor,
      product_name: fabricName,
      type: 'fabric',
    }

    if (params.style) {
      itemData.pa_cording_sku = fabric?.sku
      itemData.pa_cording_fabric_material = fabricMaterialID
    } else {
      itemData.pa_sku = fabric?.sku
      itemData.pa_fabric_material = fabricMaterialID
    }

    let cartKey = localStorage.getItem('cartKey')
    dispatch(addToCart(cartKey, fabric, itemData, true, false, this.addToCartCallback))
  }

  _isSame = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].name !== arr2[i].name || arr1[i].value !== arr2[i].value) {
        return false
      }
    }
    return true
  }

  _findCommonElement = (arr1, arr2) => {
    for (let i = 0; i < arr1.length; i++) {
      for (let j = 0; j < arr2.length; j++) {
        if (arr1[i] === arr2[j]) {
          return arr1[i]
        }
      }
    }
  }

  _moreFabricsCall(params) {
    const { dispatch, fabrics, params: propsParams } = this.props
    const { filters } = fabrics

    return getMoreFabrics(params)
      .then((res) => {
        this.setState({
          isLoadingMoreFabrics: false,
        })
        if (res) {
          let newFabrics

          if (propsParams.style) {
            newFabrics = [...fabrics.filteredCordingFabrics, ...res]
          } else {
            newFabrics = [...fabrics.filteredFabrics, ...res]
          }

          const uniqueFabrics = newFabrics.reduce((acc, fabric) => {
            if (!acc.find((f) => f.id === fabric.id)) {
              acc.push(fabric)
            }
            return acc
          }, [])

          if (propsParams.style) {
            dispatch(setFilteredCordingFabrics(uniqueFabrics))
            if (fabrics.filteredCordingFabrics.length === uniqueFabrics.length) {
              !this.state.loadedAllFabrics && displayToast('No more fabrics to load', 'info')
              this.setState({
                loadedAllFabrics: true,
                lastFabricsFilters: filters,
              })
            }
          } else {
            dispatch(setFilteredFabrics(uniqueFabrics))
            if (fabrics.filteredFabrics.length === uniqueFabrics.length) {
              !this.state.loadedAllFabrics && displayToast('No more fabrics to load', 'info')
              this.setState({
                loadedAllFabrics: true,
                lastFabricsFilters: filters,
              })
            }
          }
        } else {
          !this.state.loadedAllFabrics && displayToast('No more fabrics to load', 'info')
          this.setState({
            loadedAllFabrics: true,
            lastFabricsFilters: filters,
          })
        }
      })
      .catch((err) => {
        createError(err)
        displayToast('Fetching more fabrics failed', 'error')
      })
  }

  _loadMoreFabrics = () => {
    const { fabrics, params: propsParams, isStyle } = this.props
    const { filters } = fabrics

    const posibleFilteredFabricsLength = Array(1000)
      .fill(0)
      .map((_, index) => index * 100 + 100)

    let copyOfFilteredFabricsLength

    if (propsParams.style) {
      copyOfFilteredFabricsLength = fabrics?.filteredCordingFabrics?.length
    } else {
      copyOfFilteredFabricsLength = fabrics?.filteredFabrics?.length
    }

    let commonValue = this._findCommonElement(posibleFilteredFabricsLength, [
      copyOfFilteredFabricsLength,
      copyOfFilteredFabricsLength - 1,
    ])

    const firstCharacter = commonValue?.toString()[0]

    this.setState({ page: Number(firstCharacter) + 1 }, () => {
      const { page } = this.state
      this.setState({
        isLoadingMoreFabrics: true,
      })

      let params
      const fitlersCopy = cloneDeep(filters)
      fitlersCopy.push({
        name: 'per_page',
        value: 100,
      })
      fitlersCopy.push({
        name: 'page',
        value: page,
      })
      
      if (isStyle) {
        fitlersCopy.push(
          {
            name: 'cording_in_stock',
            value: 1,
          },
          {
            name: 'orderby',
            value: 'menu_order',
          },
          {
            name: 'order',
            value: 'asc',
          },
        )
      }

      params = setURLParams('', fitlersCopy, 'search')

      if (!this.state.loadedAllFabrics) {
        displayPromiseToast(this._moreFabricsCall(params), {
          success: 'Fabrics Loaded',
          pending: 'Loading Fabrics...',
          error: 'Something went wrong',
        })
      }
    })
  }

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    setTimeout(() => {
      getEstimate(dispatch, general, params)()
    }, 100)
  }

  _scrollDetectorFabricsSelector = () => {
    const { fabrics } = this.props
    const { frontendFilters } = fabrics

    if (this.fabricsList.current) {
      const { scrollTop, scrollHeight, clientHeight } = this.fabricsList.current
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 300

      // Load more fabrics if the scroll hit the bottom
      if (isAtBottom && !this.state.isLoadingMoreFabrics && !frontendFilters.showOnlyFavourites) {
        this._loadMoreFabrics()
      }

      if (scrollTop + clientHeight === scrollHeight) {
        if (window.innerWidth <= 375) {
          setTimeout(() => {
            this.fabricsList.current.style.overflow = 'hidden'
          }, 100)
          setTimeout(() => {
            this.fabricsList.current.style.overflow = 'auto'
          }, 750)
        }
      }
      if (scrollTop === 0) {
        if (window.innerWidth <= 375) {
          setTimeout(() => {
            this.fabricsList.current.style.overflow = 'hidden'
          }, 100)
          setTimeout(() => {
            this.fabricsList.current.style.overflow = 'auto'
          }, 750)
        }
      }
    }
  }

  _renderFabrics = () => {
    const { favouriteFabrics, isMobileDevice } = this.state
    const { general, fabrics, params } = this.props
    const { fabric, cordFabric, } = general
    let currentSelection

    const ownFabric = {
      id: 'own',
      name: 'Customer Fabric',
    }

    if (params.style) {
      currentSelection = params.style.id === 'own' && !cordFabric ? 'own' : cordFabric?.id
    } else {
      currentSelection = params.fabric.id === 'own' && !fabric ? 'own' : fabric?.id
    }

    let copyOfFilteredFabrics

    if (params.style && (fabric?.id !== 'own' || params.fabric?.id !== 'own')) {
      copyOfFilteredFabrics = [fabric, ...fabrics.filteredCordingFabrics]

      copyOfFilteredFabrics = copyOfFilteredFabrics.filter((fabric, index) => {
        const isCopy = copyOfFilteredFabrics.findIndex((f) => f?.id === fabric?.id) !== index
        return !isCopy
      })
    } else {
      copyOfFilteredFabrics = [...fabrics.filteredFabrics]
    }

    let fabricsArray = []

    fabricsArray.push(
      <div key="hardcoded-1" className="fabric-container hardcoded">
        <div className="fabric-hover-background" />
        <div
          className={`cushion-fabric-selector-card ${currentSelection === 'own' ? 'active' : ''}`}
        >
          <CustomFabric />
          <NewItemOverlay startDate={null} daysOffBeingNew={NUMBER_OF_DAYS_FOR_NEW_ITEM}>
            <div
              onClick={(e) => {
                e.stopPropagation()
                this._toggleCushionFabric(ownFabric)()
              }}
              className={`cushion-fabric-selector-card-checkbox ${currentSelection === 'own' ? 'selected' : ''}`}
            >
              {currentSelection === 'own' && (
                <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
              )}
            </div>
          </NewItemOverlay>
        </div>
        <span className={'cushion-fabric-selector-card-name-overlay'}>Customer Owned Fabric</span>
      </div>,
    )

    if (copyOfFilteredFabrics.length > 0) {
      fabricsArray = [
        ...fabricsArray,
        ...copyOfFilteredFabrics.map((fabric, index) => {
          const isFavorite = favouriteFabrics.includes(fabric?.id)
          if (fabric) {
            return (
              <div id={`fabric-${index}`} key={fabric?.id} className="fabric-container">
                <div className="fabric-hover-background" />
                <div
                  id={`checkbox-${index}`}
                  onClick={(e) => {
                    e.stopPropagation()
                    this._toggleCushionFabric(fabric)()
                  }}
                  className={`cushion-fabric-selector-card-checkbox ${fabric?.id === currentSelection ? 'selected' : ''}`}
                ></div>
                <div
                  className={`cushion-fabric-selector-card ${currentSelection === fabric?.id || isMobileDevice ? 'active' : ''} ${isFavorite ? 'favourite' : ''}`}
                >
                  <img
                    id={`fabric-img-${index}`}
                    src={fabric?.images[0]?.src}
                    onClick={this._selectCushionFabric(fabric?.id)}
                  />
                  <div className="favourite-button-container">
                    <img
                      id={`img-checkbox-${index}`}
                      onClick={this._toggleFavoriteFabric(fabric?.id, fabric?.name)}
                      className={`favourite-button ${isFavorite ? 'favourite-button-visible' : ''}`}
                      src={`${APP_URL}/wp-content/uploads/2021/11/${isFavorite ? 'heart-full' : 'heart'}.svg`}
                    />
                  </div>
                  <NewItemOverlay
                    startDate={fabric.date_created}
                    daysOffBeingNew={NUMBER_OF_DAYS_FOR_NEW_ITEM}
                  >
                    <div
                      id={`checkbox-${index}`}
                      onClick={(e) => {
                        e.stopPropagation()
                        this._toggleCushionFabric(fabric)()
                      }}
                      className={`cushion-fabric-selector-card-checkbox ${fabric?.id === currentSelection ? 'selected' : ''}`}
                    >
                      {fabric?.id === currentSelection && (
                        <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
                      )}
                    </div>
                  </NewItemOverlay>
                </div>
                <span
                  title={`${fabric?.name}`}
                  className={'cushion-fabric-selector-card-name-overlay'}
                >
                  {fabric?.name}
                </span>
              </div>
            )
          }
        }),
      ]
    }

    if (copyOfFilteredFabrics.length === 0 || fabrics.filteredCordingFabrics.length === 0) {
      fabricsArray = [
        <div className="no-fabrics-message" key={'hardcoded-2'}>
          <p>There are no fabrics that fit the criteria at this time.</p>
        </div>,
      ]
    }

    const fabricsArrayFiltered = fabricsArray.filter((fabric, index, fabricsArray) => {
      const fabricKey = fabric?.key
      const nextFabric = fabricsArray[index + 1]
      const nextFabricKey = nextFabric?.key
      return fabricKey !== nextFabricKey
    })

    return fabricsArrayFiltered
  }

  render() {
    const { isMobileLayout } = this.state
    const { fabrics, params } = this.props
    const fetchingFabrics = params.style ? fabrics.fetchingCordingFabrics : fabrics.fetchingFabrics

    return (
      <div
        className="cushion-fabric-selector-container cushion-designer-layout"
        ref={this.fabricsContianer}
      >
        {this._renderHeader()}
        {params.style ? (
          <div
            className={`${
              fabrics.filteredCordingFabrics.length === 0
                ? 'cushion-fabric-selector block'
                : 'cushion-fabric-selector'
            } ${this.state.isLoadingMoreFabrics ? 'loading-more-fabrics' : ''}`}
            ref={this.fabricsList}
            onScroll={this._scrollDetectorFabricsSelector}
          >
            {fetchingFabrics ? (
              <BarLoader
                color={'#93C44E'}
                css={
                  isMobileLayout
                    ? {
                        position: 'absolute',
                        left: '35%',
                        rigth: '50%',
                      }
                    : { position: 'absolute', left: '50%', rigth: '50%' }
                }
              />
            ) : (
              this._renderFabrics()
            )}
          </div>
        ) : (
          <div
            className={`${
              fabrics.filteredFabrics.length === 0
                ? 'cushion-fabric-selector block'
                : 'cushion-fabric-selector'
            } ${this.state.isLoadingMoreFabrics ? 'loading-more-fabrics' : ''}`}
            ref={this.fabricsList}
            onScroll={this._scrollDetectorFabricsSelector}
          >
            {fetchingFabrics ? (
              <BarLoader
                color={'#93C44E'}
                css={
                  isMobileLayout
                    ? {
                        position: 'absolute',
                        left: '35%',
                        rigth: '50%',
                      }
                    : { position: 'absolute', left: '50%', rigth: '50%' }
                }
              />
            ) : (
              this._renderFabrics()
            )}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  fabrics: state.fabrics,
})

export default withRoutingTracker(connect(mapStateToProps)(Fabrics))
